import { Image } from 'react-native';
import ls from './style';
import { BASE_IMAGE_URL } from '../../../../configs/constants';
import Button from '@sharedComponents/Button/Button';
import FadeInAnimation from '@sharedComponents/FadinAnimation/FadinAnimation';
import Svg from '@app/sharedComponents/SvgImage/Svg';
import { ThemedText, ThemedView } from '@app/theme';


const COIN_IMG =
  BASE_IMAGE_URL + 'coin.png';
const FRAME_ICON =
  BASE_IMAGE_URL + 'Frame.svg';
const SIGN_IMG =
  BASE_IMAGE_URL + 'sign.png';

const CheckEligibleCard = ({ ctaAction, t, buttonLoader,urlParams } : {ctaAction : () => void , t :any , buttonLoader : boolean, urlParams:any}) => {
  const {isPLJ,isfromTDL} = urlParams || {}
  return (
    <FadeInAnimation delay={100} duration={1000}>
      <ThemedView mx='lg' mt='2xl'>
        <ThemedView 
          zIndex={1} 
          flexDirection='row' 
          backgroundColor='bg-surface-primary' 
          borderTopLeftRadius='lg' 
          borderTopRightRadius='lg'
          borderWidth={1}
          borderBottomWidth={0}
          borderColor='border-primary'
          elevation={20}
          style={ls.shadow}>
          <ThemedView pl='md' mr='xs' pb='xl' style={ls.coinImageContainer}>
            <Image source={{ uri: COIN_IMG }} style={ls.coinImage} />
          </ThemedView>
          <ThemedView py="2xl" mx="xs" flexShrink={1} >
            <ThemedView style={ls.text}>
              <ThemedText color='text-primary' variant='h3b'>{t('cardHeading')}</ThemedText>
            </ThemedView>
            <ThemedText color='text-secondary' variant='b4m'>{t('cardSubHeading')}</ThemedText>
          </ThemedView>
        </ThemedView>
        <ThemedView 
          pb="2xl"
          flex={1}
          backgroundColor='bg-surface-primary'
          borderBottomLeftRadius='lg'
          borderBottomRightRadius='lg'
          borderWidth={1}
          borderColor='border-primary'
          borderTopWidth={0}
          >
          <ThemedView
            style={ls.buttonElevation}
            nativeID="bt_landingScreen_checkEligible">
            <Button
              overRideStyle={isfromTDL && {borderRadius:8}}
              label={isPLJ ? "Continue with application" : "Check eligible limit in 15s"}
              eventName='CHECK_ELIGIBLE_LIMIT_BUTTON'
              type={'SOLID'}
              showShadow={true}
              buttonLoader={buttonLoader}
              handlePress={ctaAction}
              showRightAccessory={true}
              rightAccessory={() => {
                return (
                  <Svg
                    url={FRAME_ICON}
                    height={24}
                    width={24}
                  />
                );
              }}
            />
          </ThemedView>
          {!isPLJ && 
          <ThemedView flexDirection='row' justifyContent='center' alignItems='center' mt="sm" >
            <ThemedView  >
              <Image source={{ uri: SIGN_IMG }} style={ls.signImg} />
            </ThemedView>
            <ThemedView ml="xs">
              <ThemedText color='text-primary' variant='b4r'>{"No impact on credit score"}</ThemedText>
            </ThemedView>
          </ThemedView>}
        </ThemedView>
      </ThemedView>
    </FadeInAnimation>
  );
};

export default CheckEligibleCard;
